<script lang="ts" setup>
const isSticky = ref(false)
let throttleTimer: NodeJS.Timeout | null = null
const handleScroll = () => {
    isSticky.value = window.scrollY > 10
    if (throttleTimer) return
    throttleTimer = setTimeout(() => {
        throttleTimer = null
    }, 100)
}
onMounted(() => {
    window.addEventListener('scroll', handleScroll, {passive: true})
})
onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
    if (throttleTimer) clearTimeout(throttleTimer)
})
</script>

<template>
  <header
          :class="{ 'header-sticky':  isSticky}"
          class="header w-full page-container flex items-center justify-between mb-4 laptop:sticky laptop:top-0 laptop:bg-white laptop:z-100 laptop:rounded-2xl transition-all py-0"
  >
    <SiteLogo class="py-4"/>
    <SiteMobileMenuButton/>
    <SiteNav/>
  </header>
</template>

<style scoped>
@media (max-width: 767px) {
    .header {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }
}
</style>